import { Box, Button, Divider, Popover, Typography } from '@mui/material';
import { Logout as LogoutIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

export const ProfilePopover = ({ isProfileOpen, anchorEl, handleCloseProfile, account, logout }) => {
    const { t } = useTranslation();
    return (
        <Popover
            open={isProfileOpen}
            anchorEl={anchorEl}
            onClose={handleCloseProfile}
            aria-hidden={false}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
        >
            <Box
                sx={{
                    width: 200,
                    p: 2,
                }}
            >
                <Typography variant="h6" sx={{ mb: 1 }}>
                    {account.username}
                </Typography>
                <Typography
                    sx={{
                        fontSize: '0.85rem',
                        color: 'text.secondary',
                        mb: 1,
                    }}
                >
                    Role: {account.role}
                </Typography>
                <Divider sx={{ my: 1 }} />
                <Button
                    startIcon={<LogoutIcon />}
                    variant="outlined"
                    fullWidth
                    onClick={() => {
                        logout();
                        handleCloseProfile();
                    }}
                >
                    {t('MODAL.LOGOUT')}
                </Button>
            </Box>
        </Popover>
    );
};
